<h1 mat-dialog-title>Previsualización de Formulario</h1>

<mat-dialog-content class="create-form">
  <mat-form-field *ngFor="let field of fields">
    <input matInput [disabled]="true" placeholder="{{field.formulario_campo_nombre}}" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)='createFieldForm()'>Agregar nuevo campo</button>
  <button mat-raised-button (click)='closeMe()'>Cerrar</button>
</mat-dialog-actions>
